
export default {
	// loading indicators
	loading: {},

	// individual settings of product to add to cart
	cartItem: {
		// when expressing inches as 12 and 1/2, '12' is the whole amount and the remainder is the fractional amount '1/2'
		width: { whole: '', fractional: '' },
		height: { whole: '', fractional: '' },
		room: '',
		qty: 1,
		mountPos: 'inside',
	},

	// headrail options
	headrailNum: 1,
	headrailControls: 'left',
	headrailSizes: [
		{ whole: '', fractional: '' },
		{ whole: '', fractional: '' },
		{ whole: '', fractional: '' },
	],

	// selected option data
	optionSelections: {},

	// data about product being customized
	product: {},
	options: {},
	optionsByType: {},
	optionIds: [],

	// customized product summary
	summary: { 
		product_price: 0,
		total: 0,		
	},
}